<template>
  <div
    class="w-full flex flex-wrap lg:flex-nowrap items-stretch gap-2 p-px bg-slate-50 flex space-x-2"
  >
    <div class="flex flex-wrap justify-start gap-2 w-full lg:w-auto lg:flex-1">
      <slot name="left-buttons" />
    </div>
    <div
      class="flex flex-wrap justify-end gap-2 w-full lg:w-auto lg:flex-1 lg:justify-end"
    >
      <slot name="right-buttons" />
    </div>
  </div>
</template>
